export default __webpack_public_path__ + "static/media/item_6.71a7567e.webp";